import React, { useState } from "react";
import { useLocation } from "react-router-dom";
const Sidebar = ({
 bookmarks = [],
 showAuthButtons = true,
 showBookmarks = true,
}) => {
 const location = useLocation();
 const [bookmarksExpanded, setBookmarksExpanded] = useState(false);
 const isLoginPage = location.pathname === "/";
 const toggleBookmarks = () => setBookmarksExpanded((v) => !v);
 const hasLoginInfo =
   !!localStorage.getItem("user_ntid") &&
   !!localStorage.getItem("last_login") &&
   !isLoginPage;
 return (
<div className="sidebar">
     {/* IPRU logo */}
<div className="ipru-logo-container">
<img className="ipru-logo" src="/Ipru_logo.jpg" alt="IPRU Logo" />
</div>
     {/* Logged-in info */}
     {!isLoginPage && hasLoginInfo ? (
<div style={{ fontSize: "12px", color: "white", padding: "10px 0" }}>
         Logged in as: <strong>{localStorage.getItem("user_ntid")}</strong>
<br />
         Last login: <strong>{localStorage.getItem("last_login")}</strong>
</div>
     ) : null}
     {/* Bookmarks */}
     {showBookmarks && (
<div className="bookmark-section">
<button
           className="bookmark-toggle"
           onClick={toggleBookmarks}
           aria-expanded={bookmarksExpanded}
           aria-controls="bookmark-list"
>
           {bookmarksExpanded ? "Hide Bookmarks" : "My Bookmarks"}
</button>
         {bookmarksExpanded && (
<div className="bookmark-list" id="bookmark-list">
             {bookmarks.length === 0 ? (
<p style={{ margin: 0 }}>No bookmarks</p>
             ) : (
<ul>
                 {bookmarks.map((bm, idx) => (
<li key={`${idx}-${bm}`}>{bm}</li>
                 ))}
</ul>
             )}
</div>
         )}
</div>
     )}
     {/* UI image */}
<div className="ui-image-container">
<img className="ui-image" src="/UI_Img.png" alt="UI" />
</div>
     {/* Footer */}
<div className="bottom-section">
<div className="dev-text">Designed &amp; Developed by BIU</div>
</div>
</div>
 );
};
export default Sidebar;